import { Injectable } from '@angular/core';
import { HealthCheckHttpService } from '@cp/shared/data-access/http/health-check/health-check-http.service';

@Injectable({
  providedIn: 'root',
})
export class HealthCheckService {
  public healthCheck$ = this._healthCheckHttpService.healthCheck$;

  constructor(private _healthCheckHttpService: HealthCheckHttpService) {}
}
